import { DashboardPage } from "@modules/dashboard";
import { ProfilePage } from "@modules/userprofile";
import { SignInPage, SignUpPage, LogoutPage } from "@modules/auth";

// @mui icons
import {
    DashboardCustomize,
    Login,
    Person,
    Assignment,
    Logout,
    RequestQuote, Settings, AccessTimeFilled, PersonAdd,
    HeadsetMic,
} from "@mui/icons-material";
import NotPermission from "@shared/ui/Error";
import PrivateRoute from "./PrivateRoute";
import {
    VacancyPage,
    VacancyListPage,
    JobDetailPage,
    CandidateSendPage,
} from "@modules/vacancy";
import { ManagementRequestPage, RegisterRequestPage } from "@modules/licenseapplication";
import { ManagementHourPage, ChargeHourPublicPage } from "@modules/timeentry";
import { PreInvoicePage, PreInvoiceVisualizerPage } from "@modules/preinvoice";
import {
    ManagementInvoicePage,
    InvoicePage,
    InvoicesVisualizerPage,
    InvoiceDetailsPage,
    ConfirmationInvoicePublicPage,
} from "@modules/invoice";
import { ReferredCommissionPage } from "@modules/commission";
import {
    PeopleAndCulturePage,
    BenefitsPage,
    AdministrationPage,
    FormationPage,
} from "@modules/cms";
import { AdminPage } from "@modules/admin";
import { ManagementReservationPage } from "@modules/reservation";
import { SupportPage } from "@modules/support";
import type { RouteItem } from "./routes.types";

const routes: RouteItem[] = [
    {
        type: "collapse",
        name: "people-and-culture",
        key: "people-and-culture",
        icon: <DashboardCustomize fontSize="small"/>,
        route: "/people-and-culture",
        auth: true,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PrivateRoute><PeopleAndCulturePage/></PrivateRoute>,
    },
    {
        type: "collapse",
        name: "formación",
        key: "formación",
        icon: <DashboardCustomize fontSize="small"/>,
        route: "/formacion",
        auth: true,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PrivateRoute><FormationPage/></PrivateRoute>,
    },
    {
        type: "collapse",
        name: "administración",
        key: "administracion",
        icon: <DashboardCustomize fontSize="small"/>,
        route: "/administracion",
        auth: true,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PrivateRoute><AdministrationPage/></PrivateRoute>,
    },
    {
        type: "collapse",
        name: "beneficios",
        key: "beneficios",
        icon: <DashboardCustomize fontSize="small"/>,
        route: "/beneficios",
        auth: true,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PrivateRoute><BenefitsPage/></PrivateRoute>,
    },
    {
        type: "collapse",
        name: "Inicio",
        key: "inicio",
        icon: <DashboardCustomize fontSize="small"/>,
        route: "/inicio",
        auth: true,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PrivateRoute><DashboardPage/></PrivateRoute>,
    },
    {
        type: "collapse",
        name: "gestion-de-vacantes",
        key: "gestion-de-vacantes",
        icon: <Settings fontSize="small"/>,
        route: "/gestion-de-vacantes",
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PrivateRoute><VacancyPage/></PrivateRoute>,
    },
    {
        type: "collapse",
        name: "vacantes",
        key: "vacantes",
        icon: <Settings fontSize="small"/>,
        route: "/gestion-de-vacantes/vacantes",
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PrivateRoute><VacancyListPage/></PrivateRoute>,
    },
    {
        type: "collapse",
        name: "Ofertas De Empleos",
        key: "view-job-offer",
        icon: <Settings fontSize="small"/>,
        route: "/gestion-de-vacantes/vacantes/:id",
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PrivateRoute><JobDetailPage/></PrivateRoute>,
    },
    {
        type: "collapse",
        name: "Ofertas De Empleos",
        key: "view-job-offer",
        icon: <Settings fontSize="small"/>,
        route: "/gestion-de-vacantes/candidatos",
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PrivateRoute><CandidateSendPage/></PrivateRoute>,
    },
    {
        type: "collapse",
        name: "Gestion de Solicitud",
        key: "request",
        icon: <Settings fontSize="small"/>,
        route: "/solicitudes",
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PrivateRoute><ManagementRequestPage/></PrivateRoute>,
    },
    {
        type: "collapse",
        name: "Gestion de Solicitud",
        key: "request",
        icon: <Settings fontSize="small"/>,
        route: "/solicitudes/registro",
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PrivateRoute><RegisterRequestPage/></PrivateRoute>,
    },
    {
        type: "collapse",
        name: "Gestion de Reservas",
        key: "gestion-de-reservas",
        icon: <AccessTimeFilled fontSize="small"/>,
        route: "/gestion-de-reservas",
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PrivateRoute><ManagementReservationPage/></PrivateRoute>,
    },
    {
        type: "collapse",
        name: "Gestión de Horas",
        key: "gestion-de-horas",
        icon: <AccessTimeFilled fontSize="small"/>,
        route: "/gestion-de-horas",
        auth: true,
        component: <PrivateRoute><ManagementHourPage/></PrivateRoute>,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
    },
    {
        type: "collapse",
        name: "Referenciados",
        key: "referenciados",
        icon: <PersonAdd fontSize="small"/>,
        route: "/referenciados",
        auth: true,
        component: <PrivateRoute><ReferredCommissionPage/></PrivateRoute>,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
    },
    //
    // {
    //     type: "collapse",
    //     name: "Gestión de Horas",
    //     key: "registro-descriptivo",
    //     icon: <AccessTimeFilled fontSize="small"/>,
    //     route: "/gestion-de-horas/registro-descriptivo",
    //     auth: true,
    //     component: <RegisterHourDescriptiveComponent/>,
    //     roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
    // },
    //
    //
    {
        type: "collapse",
        name: "Ofertas De Empleos",
        key: "gestion-de-facturas",
        icon: <Settings fontSize="small"/>,
        route: "/gestion-de-facturas",
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PrivateRoute><ManagementInvoicePage/></PrivateRoute>,
    },
    {
        type: "collapse",
        name: "Ofertas De Empleos",
        key: "facturas",
        icon: <Settings fontSize="small"/>,
        route: "/gestion-de-facturas/facturas",
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PrivateRoute><InvoicePage/></PrivateRoute>,
    },
    {
        type: "collapse",
        name: "Ofertas De Empleos",
        key: "prefactura",
        icon: <Settings fontSize="small"/>,
        route: "/gestion-de-facturas/prefactura",
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PrivateRoute><PreInvoicePage/></PrivateRoute>,
    },
    {
        type: "collapse",
        name: "Ofertas De Empleos",
        key: "prefactura",
        icon: <Settings fontSize="small"/>,
        route: "/gestion-de-facturas/prefactura/ver",
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PrivateRoute><PreInvoiceVisualizerPage/></PrivateRoute>,
    },
    {
        type: "collapse",
        name: "Ofertas De Empleos",
        key: "ver",
        icon: <Settings fontSize="small"/>,
        route: "/gestion-de-facturas/facturas/ver",
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PrivateRoute><InvoicesVisualizerPage/></PrivateRoute>,
    },
     {
        type: "collapse",
        name: "Ofertas De Empleos",
        key: "ver",
        icon: <Settings fontSize="small"/>,
        route: "/gestion-de-facturas/factura/ver/:invoiceSubmissionId",
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PrivateRoute><InvoiceDetailsPage/></PrivateRoute>,
    },
    {
        type: "collapse",
        name: "Administración",
        key: "administracion",
        icon: <Settings fontSize="small"/>,
        route: "/panel-administrativo",
        auth: true,
        component: <PrivateRoute><AdminPage/></PrivateRoute>,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
    },
    {
        type: "collapse",
        name: "Profile",
        key: "perfil",
        icon: <Person fontSize="small"/>,
        route: "/perfil",
        auth: true,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL', 'TELEFONICA', 'VISUALIZER'],
        component: <PrivateRoute><ProfilePage /></PrivateRoute>,
    },
    {
        type: "collapse",
        name: "Sign In",
        key: "sign-in",
        icon: <Login fontSize="small"/>,
        route: "/",
        auth: false,
        roles: ['PUBLIC'],
        component: <SignInPage/>,
    },
    {
        type: "collapse",
        name: "Sign Up",
        key: "sign-up",
        icon: <Assignment fontSize="small"/>,
        route: "/authentication/sign-up",
        auth: false,
        roles: ['ADMINISTRATOR'],
        component: <SignUpPage/>,
    },
    {
        type: "collapse",
        name: "Cerrar Sesión",
        key: "Cerrar Sesión",
        icon: <Logout fontSize="small"/>,
        route: "/logout",
        auth: false,
        roles: ['PUBLIC'],
        component: <LogoutPage/>,
    },
    {
        type: "collapse",
        name: "Sin Permisos",
        key: "Sin Permisos",
        icon: <RequestQuote fontSize="small"/>,
        route: "/not-permission",
        auth: true,
        component: <NotPermission/>,
        roles: ['PUBLIC'],
    },
    {
        type: "collapse",
        name: "Charge Hour",
        key: "charge-hour",
        icon: <Login fontSize="small"/>,
        route: "/charge-hour/:id/:token/:projectName/:localDate/:type",
        auth: false,
        roles: ['PUBLIC'],
        component: <ChargeHourPublicPage/>,
    },

    {
        type: "collapse",
        name: "Charge Hour",
        key: "charge-hour",
        icon: <Login fontSize="small"/>,
        route: "/comfimation/invoice/:token/:id",
        auth: false,
        roles: ['PUBLIC'],
        component: <ConfirmationInvoicePublicPage/>,
    },
    {
        type: "collapse",
        name: "support",
        key: "support",
        icon: <HeadsetMic fontSize="small"/>,
        route: "/soporte",
        auth: true,
        component: <PrivateRoute><SupportPage/></PrivateRoute>,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
    },
];

export default routes;
